const BLOCKED_PROTOCOL = /^(javascript|data|vbscript|file):/i;

const parseExtraOrigins = () => {
  const raw = process.env.REACT_APP_ALLOWED_FILE_ORIGINS;
  if (!raw || typeof raw !== 'string') return [];
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

const apiOrigin = () => {
  const base = process.env.REACT_APP_API_URL;
  if (!base || typeof base !== 'string') return null;
  try {
    return new URL(base).origin;
  } catch {
    return null;
  }
};

const collectAllowedOrigins = () => {
  const origins = new Set(parseExtraOrigins());
  const api = apiOrigin();
  if (api) origins.add(api);
  if (typeof window !== 'undefined') {
    origins.add(window.location.origin);
  }
  return origins;
};

/**
 * Returns whether a file URL may be used in the preview/download UI (SSRF / open-redirect guard).
 * Allows: current app origin, API origin from REACT_APP_API_URL, and REACT_APP_ALLOWED_FILE_ORIGINS.
 * @param {unknown} value
 * @returns {boolean}
 */
export const isAllowedFileUrl = (value) => {
  if (value == null || typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (BLOCKED_PROTOCOL.test(trimmed)) return false;

  let url;
  try {
    url = new URL(trimmed);
  } catch {
    if (typeof window === 'undefined') return false;
    try {
      url = new URL(trimmed, window.location.origin);
    } catch {
      return false;
    }
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

  return collectAllowedOrigins().has(url.origin);
};
